import type { GetStaticProps } from "next";
import Head from "next/head";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";

import { getAllEvents } from "~/api/events/getAllEvents";
import { getTags } from "~/api/tags/getTags";
import AccountDisplay from "~/components/account/display";
import AccountIntro from "~/components/account/intro";
import Spacer from "~/components/common/spacer";
import PendingPaymentCard from "~/components/PendingPaymentCard";
import Modal from "~/components/ui/modal";
import PrivatePage from "~/components/wrappers/PrivatePage";
import ValidatedPage from "~/components/wrappers/ValidatedPage";
import { EventType } from "~/types/event/event.types";
import { FilterTagsEnum, TagType } from "~/types/tag/tag.types";

interface Props {
  tags: TagType[];
  events: EventType[];
}

export const getStaticProps: GetStaticProps<Props> = async () => {
  const tags = await getTags(FilterTagsEnum.EVENTS);
  const events = await getAllEvents();
  return { props: { tags, events } };
};

const Account = ({ tags, events }: Props) => {
  const { data } = useQuery("events", getAllEvents);
  const { query } = useRouter();
  const [modal, setModal] = useState(false);

  useEffect(() => {
    if (query.return_from_stripe) setModal(true);
  }, [query]);

  return (
    <PrivatePage>
      <ValidatedPage>
        <Head>
          <title>Silencio - Account</title>
        </Head>
        <Spacer width={"100%"} height={"150px"} />
        <AccountIntro />
        <Spacer width={"100%"} height={"30px"} />
        <AccountDisplay events={data ?? events} tags={tags} />
      </ValidatedPage>

      <Modal open={modal}>
        <PendingPaymentCard
          close={() => {
            setModal(false);
          }}
        />
      </Modal>
    </PrivatePage>
  );
};

export default Account;
